import React, { Component } from "react"
import PropTypes from "prop-types"
import {
  DropdownMenu,
  DropdownToggle,
  Dropdown,
} from "reactstrap"

import EntityType from "api/SirenEntityType"
import { findByName } from "api/actions"
import Logout from "components/Layout/Header/Logout"
import FontAwesomeIcon from "components/FontAwesome/FontAwesomeIcon"

class HeaderDropdown extends Component {
  static propTypes = {
    entity: EntityType,
    className: PropTypes.string,
  }

  state = { dropdownOpen: false }
  toggle = () => this.setState(() => ({ dropdownOpen: !this.state.dropdownOpen }))

  render() {
    const { properties, actions } = this.props.entity
    const logoutAction = findByName(actions, "logout")

    return <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle} className={this.props.className}>
      <DropdownToggle nav>
        <FontAwesomeIcon title={properties.icon} iconURI={properties.icon} fontSize="23px"/>
      </DropdownToggle>
      <DropdownMenu right>
        <Logout action={logoutAction} btnClassName="dropdown-item"/>
      </DropdownMenu>
    </Dropdown>
  }
}

export default HeaderDropdown
